import React from "react";
import UniqNeedsBG from "./img/unique-needs-bg.jpg";
import Unique from "./img/unique-need.png";
import HTMLReactParser from "html-react-parser";
import "./style.scss";
import { useTranslation } from 'react-i18next';

export default function FindAMentor(props) {
  const { t } = useTranslation();
  const keyData = props.data;
  return (
    <div className="uniqeNeedBg">
      <section
        style={{
          // background:UniqNeedsBG,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
        id="unique"
      >
        <div class="w-100 pt-50 pb-50 position-relative">
          <div class="container">
            <div class="row">
              <div class="sec-title text-center w-100 position-relative">
                <h2 class="mb-0 homepageFirstHeader">
                {t('Find_Mentor_Your_Unique_Needs')}
                  {/* Find a Mentor for Your Unique Needs */}
                  </h2>
              </div>
            </div>
          </div>

          <div class="container-fluid" id="line">
            <div class="row">
              <div
                class="col-md-12 col-sm-6 col-lg-12"
                style={{ padding: "0px" }}
              >
                <img src={Unique} style={{ width: "100%" }} />
              </div>
            </div>
          </div>
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-1 col-sm-6 col-lg-1">
                {/* <!-- <img src="assets/images/unique-need.png"> --> */}
              </div>
              {keyData.map((data, index) => {
                return (
                  <div class="col-md-2 col-sm-6 col-lg-2" key={index}>
                    <div class="unique-sec">
                      <a class="unique-heading homepageFirstDescription" style={{ fontSize: "20px",whiteSpace:"normal" }}>
                        {data.Heading}
                      </a>
                      <div className="homepageFirstDescription" >
                      {HTMLReactParser(data.Text)}
                      </div>
                    </div>
                  </div>
                );
              })}

              <div class="col-md-1 col-sm-6 col-lg-1">
                {/* <!-- <img src="assets/images/unique-need.png"> --> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
